// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"223":"310b5e71","371":"f844b5a1"}[chunkId] + ".js";
};